/* Radiobuttons */
(function ($) {
    $(document).on('change', '.gfield_radio input', function () {
        if ($(this).is(':checked')) {
            $(this).parent().addClass('__checked');
            $(this).parent().siblings().removeClass('__checked');
        }
    });
})($);

(function ($) {
    $('.gfield_radio input:checked')
        .parent().addClass('__checked');
})($);

/* Checkboxes */
(function ($) {
    $(document).on('change', '.gfield_checkbox input', function () {
        if ($(this).is(':checked')) {
            $(this).parent().addClass('__checked');
        } else {
            $(this).parent().removeClass('__checked');
        }
    });
})($);

(function ($) {
    $('.gfield_checkbox input:checked')
        .parent().addClass('__checked');
})($);

/* Focus state */
(function ($) {
    $(document).ready(function () {
        $('.gfield_radio input').focus(function () {
            $(this).parent().addClass('__focused');
        }).blur(function () {
            $(this).parent().removeClass('__focused');
        });
        $('.gfield_checkbox input').focus(function () {
            $(this).parent().addClass('__focused');
        }).blur(function () {
            $(this).parent().removeClass('__focused');
        });
    });
})($);

/* Consent checkbox */
(function ($) {
    $(document).on('change', '.ginput_container_consent input', function () {
        if ($(this).is(':checked')) {
            $(this).parent().addClass('__checked');
        } else {
            $(this).parent().removeClass('__checked');
        }
    });
})($);

(function ($) {
    $('.gfield_checkbox input:checked')
        .parent().addClass('__checked');
})($);